import React from 'react';
import { defineMessages, T, t } from '@sm/intl';
import { createURL } from '@sm/utils';
import { List } from '@wds/list';
import { Responsive } from '@wds/responsive';
import { NavButton } from '../nav-button';

const COPY = defineMessages({
  HOME: {
    id: 'Home.home',
    defaultMessage: 'Home',
    description: '[Type: Label][Vis.: low] - Home button of nav bar',
  },
});

const Home = () => {
  const url = createURL('/', { ut_source: 'header' });
  const title = t(COPY.HOME);

  return (
    <>
      <Responsive minWidth="xl">
        {matches =>
          matches ? (
            <li>
              <NavButton href={url} label={title}>
                <T desc={COPY.HOME} />
              </NavButton>
            </li>
          ) : (
            <List.Item isNavigable href={url}>
              <T desc={COPY.HOME} />
            </List.Item>
          )
        }
      </Responsive>
    </>
  );
};

export default Home;
export { Home };
